import { Button } from "@carbon/react";

import { TextInput } from "../../ui";
import { FormContainer } from "../../components";
import switchAppLogo from "../../assets/icons/switchapp-logo.svg";
import { Link } from "react-router-dom";

export const View = () => {
  return (
    <div className="auth-page--container flex-container col justify-content--center align-items--center">
      <div>
        <div className="logo-container flex-container justify-content--start">
          <img src={switchAppLogo} alt="logo" />
        </div>

        <FormContainer>
          <div className="form-container flex-container col">
            <div className="form-container__header font-ctm--bold">
              <h3>Forgot Password</h3>
            </div>

            <div className="form-container__body">
              <div className="form-container__body__input-container">
                <TextInput label="Email" />
              </div>

              <div className="flex-container buttons-container">
                <Button className="flex-box switchapp-themed">Submit</Button>
              </div>
            </div>
          </div>

          <div className="form-container__footer">
            <p className="switchapp-small">
              Don't have an account? <Link to={"/signup"}>Sign up</Link>
            </p>
          </div>
        </FormContainer>
      </div>

      {/* go back to sign in page */}
      <div className="switchapp-small go-back--link mt-5 font-ctm--bold">
        <Link to={"/signin"}>Go Back</Link>
      </div>
    </div>
  );
};
